import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGOUT_USER,
  LOAD_USER_SUCCESS,
  START_LOADING,
  STOP_LOADING,
  LOAD_LOJA_SUCCESS,
  LOAD_LOJA_FAIL,
  UPDATE_LOJA_SUCCESS,
  UPDATE_LOJA_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
} from "../actions/user";

const initialState = {
  profile: null,
  loja: null,
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        error: null,
        loading: false,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        error: null,
        loading: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        profile: null,
        error: action.payload,
        loading: false,
      };
    case LOAD_LOJA_SUCCESS:
      return { ...state, loja: action.payload, error: null, loading: false };
    case LOAD_LOJA_FAIL:
      return { ...state, loja: null, error: action.payload, loading: false };
    case UPDATE_LOJA_SUCCESS:
      return { ...state, loja: action.payload, error: null, loading: false };
    case UPDATE_LOJA_FAIL:
      return { ...state, error: action.payload, loading: false };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload, // Atualiza o nome e email
        },
        error: null,
        loading: false,
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case LOGOUT_USER:
      return initialState;
    default:
      return state;
  }
};

export default userReducer;
